import styled from 'styled-components';
import EmptyState from 'src/modules/community/communityMembers/communityMembersEmptyState';
import Pagination from 'src/components/pagination/pagination';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';
import CommunityMemberCard from 'src/modules/community/communityMembers/communityMemberCard';
import ImproveSimilarToMeRecommendationsCard from 'src/modules/community/communityMembers/improveSimilarToMeRecommendationsCard';
import { useSelector } from 'src/store/store';
export default function MembersList() {
  const {
    members,
    total
  } = useSelector(({
    pages
  }) => pages.communityMembers.data);
  const filter = useSelector(({
    pages
  }) => pages.communityMembers.currentFilter);
  if (!members?.length) return <EmptyState />;
  return <>
      <CommunityMembersList data-sentry-element="CommunityMembersList" data-sentry-source-file="communityMembersList.tsx">
        {members.map(member => <CommunityMemberCard key={member.username} member={member} />)}
      </CommunityMembersList>
      <Pagination pageSize={paginationResultsPerPage.searchMembers} total={total} data-sentry-element="Pagination" data-sentry-source-file="communityMembersList.tsx" />
      {filter === 'similar-to-me' && <ImproveSimilarToMeRecommendationsCard />}
    </>;
}
const CommunityMembersList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;